/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InvoiceStatsResponse,
  ListInvoicesResponse,
} from '../models/index';
import {
    InvoiceStatsResponseFromJSON,
    InvoiceStatsResponseToJSON,
    ListInvoicesResponseFromJSON,
    ListInvoicesResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class InvoicesApi extends runtime.BaseAPI {

    /**
     * Your GET endpoint
     */
    async getInvoiceStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/invoice-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceStatsResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getInvoiceStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceStatsResponse> {
        const response = await this.getInvoiceStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async listInvoicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvoicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async listInvoices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvoicesResponse> {
        const response = await this.listInvoicesRaw(initOverrides);
        return await response.value();
    }

}
